import React from 'react';

import { Title, Button } from 'common/components';
import { Glossary, CompletionGL } from 'common/utils/glossary';

interface Props {
  /** グロッサリ */
  glossary: Glossary;
  /** 利用解除済みか否か */
  isCancellationConfirmation: boolean;
  /** プラン一覧への遷移処理 */
  movePlanList: () => void;
  /** 契約中への遷移処理 */
  moveContractList: () => void;
  /** ログアウトへの遷移処理 */
  moveLogOut: () => void;
}

/**
 * 解約完了画面のPresentation Component
 */
export const DeleteCompletionPage: React.FC<Props> = ({
  glossary,
  isCancellationConfirmation,
  movePlanList,
  moveContractList,
  moveLogOut
}) => {
  // 解約完了画面
  return (
    <div className="information" data-test="deleteCompletion">
      <Title type="title" data-test="deleteCompletionTitle">
        {isCancellationConfirmation == false
          ? glossary.glx(CompletionGL.ThankDelete)
          : glossary.glx(CompletionGL.ThankReturn)}
      </Title>
      <Button
        type="nextButton"
        data-test="deleteCompletionPlanBtn"
        onClick={movePlanList}
      >
        {glossary.glx(CompletionGL.ToPlanList)}
      </Button>
      <Button
        type="nextButton"
        data-test="deleteCompletionContractBtn"
        onClick={moveContractList}
      >
        {glossary.glx(CompletionGL.ToContractList)}
      </Button>
      <Button
        type="nextButton"
        data-test="deleteCompletionLogoutBtn"
        onClick={moveLogOut}
      >
        {glossary.glx(CompletionGL.ToLogout)}
      </Button>
    </div>
  );
};
